<script>
	import moment from "moment";
	import { onDestroy,onMount } from "svelte";
	import { get } from "svelte/store";
	import LoadState from "../Enums/LoadState";
	import FiltersButtonMenu from "../Filters/FiltersButtonMenu.svelte";
	import FiltersComponent from "../Filters/FiltersComponent.svelte";
	import MapLayer from "../Map/Enums/MapLayer";
	import MapStore from "../Map/Store";
	import AircraftProperty from "../Models/Enums/AircraftProperty";
	import MenuItem from "../UI/FlyoutMenu/MenuItem.svelte";
	import Spinner from "../UI/Spinner/Spinner.svelte";
	import SpinnerSize from "../UI/Spinner/SpinnerSize";
	import TimeSlider from "../UI/TimeSlider/TimeSlider.svelte";
	import AircraftStore from "./AircraftStore";
	
	onMount(() => {
		AircraftStore.actions.init();
	});

	onDestroy(()=>{
		AircraftStore.actions.deinit();
	});

	let initialised = false;
	let loadState = AircraftStore.meta.loadState;
	$: {
		initialised = ($loadState === LoadState.LOADED);
	}

	let aircraft = AircraftStore.results.group.vessels;
	let aircraftFiltered = AircraftStore.results.filtered;
	let aircraftSelected = AircraftStore.results.group.selected["registration"];

	// Time Slider
	let timeSliderData = AircraftStore.results.group.timeSliderData;
	$: {
		updateTimeSliderMinMax();
	}
	let updateTimeSliderMinMax = () => {
		const now = moment();
		let minDate = moment(now).subtract(12, "hours"); //startOf("day");
		let maxDate = moment(now);//.add(1, "day");
		timeSliderData.min.set(minDate);
		timeSliderData.max.set(maxDate);
		timeSliderData.step.set(300);
		timeSliderData.value.set(get(timeSliderData.max));
	};
	// Update "current" weather item when the timeslider changes.

	AircraftStore.results.group.timeSliderData.value.subscribe((value) => {
		$aircraft.forEach(one => one.updateSnapshot(value));
		AircraftStore.actions.update();
	});

	// AircraftStore.results.group.onFocusedChanged.add((aircrafts) => {
	// 	// TODO: If we have to have a focus event / magnifying glass button on other lists, consider moving into Vessel Group.
	// 	if (aircrafts.length > 0) {
	// 		MapStore.helpers.moveToPoint(aircrafts[aircrafts.length-1].coordinates);
	// 		//aircrafts[aircrafts.length-1].updateSnapshot(value));
	// 		AircraftStore.actions.update();
	// 	}
	// });
	let rawSelectedRegistrations = AircraftStore.results.group.selected[AircraftProperty.REGISTRATION];

	let contextMenu;
	let filters = AircraftStore.filters.advanced;
	let filtersLastUpdated = AircraftStore.filters.lastUpdated;
	let advancedFiltersUpdated = filters.lastUpdated;

	$: {
		$rawSelectedRegistrations;
		$filtersLastUpdated = $advancedFiltersUpdated;
		filters = filters;

		AircraftStore.filters.lastUpdated.set(new Date());
		AircraftStore.actions.update();
	}

	// Set up the map input handler/s.
	MapStore.meta.initialised.subscribe((initialised)=>{
		if (initialised) {
			const map = MapStore.helpers.getMap();
			map.on("click", MapLayer.AIRCRAFT_FAKE_LIVE, event => {
				event.preventDefault();

				AircraftStore.results.group.selectSingle(map, event, [MapLayer.AIRCRAFT_FAKE_LIVE], [AircraftProperty.REGISTRATION]);
			});

			map.on("click", MapLayer.AIRCRAFT_FAKE_HISTORIC_POINTS, event => {
				event.preventDefault();
				let features = map.queryRenderedFeatures(event.point, {
					layers: [MapLayer.AIRCRAFT_FAKE_HISTORIC_POINTS]
				});
				if (features.length) {
					const feature = features[0];
					const featureTimeStamp = feature.properties[AircraftProperty.TIMESTAMP]
					if(featureTimeStamp) {
						AircraftStore.results.group.timeSliderData.value.set(moment(new Date(featureTimeStamp)));
					}
				}
			});
		}
	});

</script>
<MenuItem title={"Aircraft"} materialIcon={"flight"} class="filters-component">
	<div slot="context-menu">
		{#if initialised}
			<FiltersButtonMenu filters={filters} hackStyle={"left:-152px;"}/>
		{/if}
	</div>
	<div class="content">
		{#if !initialised}
			<p style="text-align:center;margin:0px;overflow:auto;height:48px;">
				<Spinner size={SpinnerSize.SMALL} absolute={false} inline={true} />
			</p>
		{:else}
			<FiltersComponent name="aircraft" filters={filters} />

			<p><b>Total:</b> {$aircraft.length}</p>
			<p><b>Filtered:</b> {$aircraftFiltered.length}</p>
		{/if}
	</div>
</MenuItem>

<TimeSlider data={timeSliderData} hasNowButton={true} />
